// extracted by mini-css-extract-plugin
export default {"asterisk":"IconAsterisk_asterisk__bSfLO"};